export const SIDENAV = {
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
};